import { useNotificationApi } from "../context/NotificationProvider";


export const useNotifier = () => {
  const api = useNotificationApi();

  return {
    success: (message: string, description?: string) =>
      api.success({ message, description, placement: 'bottomRight' }),
    error: (message: string, description?: string) =>
      api.error({ message, description, placement: 'bottomRight' }),
    info: (message: string, description?: string) =>
      api.info({ message, description, placement: 'bottomRight' }),
    warning: (message: string, description?: string) =>
      api.warning({ message, description, placement: 'bottomRight' }),
  };
};